import Fraction from './fraction.js'

export const zero = new Fraction(0);
export const one = new Fraction(1);
export const minus = new Fraction(-1);

export class InputField{
  constructor(val = '0'){
    this.txt = '0';
    this.error = true;
    this.frac = zero;
    this.input = val;
  }
  get input(){
    return this.txt;
  }
  set input(val){
    this.txt = val;
    this.error = false;
    try{
      this.frac = Fraction(this.txt);
    }catch(e){
      this.error = true;
    }
  }
}

export class IndexField{
  constructor(val='1'){
    this._val = val;
  }
  set val(txt){
    if(txt.match(/^[0-9]+$/)){
      this._val = txt;
    }
  }
  get val(){
    return this._val;
  }
}

export class Operation{
  constructor(type='calc',num=1,rc='row',i1=0,i2=1){
    this.num = num; // id of matrix 1-n, // 0 for unique matrix
    this.type = type; // calc, surrus, mult, swap, add, deg, expand
    this.rc = rc; // row,col
    this.expand_i = i1;
    this.mult_i = i1;
    this.swap_i1 = i1;
    this.swap_i2 = i2;
    this.add_i1 = i1;
    this.add_i2 = i2;
    this.coeff_mult = new InputField('1');
    this.coeff_add = new InputField('0');
  }
  get message(){
    if(this.type == 'mult' && this.coeff_mult.error || this.type == 'add' && this.coeff_add.error){
      return 'スカラー(有理数)の入力に誤りがあります。';
    }else if(this.type == 'mult' && this.coeff.equals(zero)){
      return '0をかけることはできません。';
    }else if(this.type == 'swap' && this.swap_i1 == this.swap_i2){
      return this.rcTxt + '番号が同一です。';
    }else if(this.type == 'add' && this.add_i1 == this.add_i2){
      return this.rcTxt + '番号が同一です。';
    }else if(this.type == 'add' && this.coeff.equals(zero) || this.type == 'mult' && this.coeff.equals(one)){
      return 'この操作で行列は変化しません。';
    }else{
      return '';
    }
  }
  get coeff(){
    return this.type == 'mult' ? this.coeff_mult.frac : this.coeff_add.frac;
  }
  get rcTxt(){
    return this.rc == 'row' ? '行' : '列';
  }
  txt(showNum=false,eqn=false){
    let txt = '';
    const rc = eqn ? '式' : (this.rc == 'row' ? '行' : '列');
    const coeff = (this.coeff.s == -1 ? `(${this.coeff.toFraction()})` : this.coeff.toFraction());
    if(showNum){
      txt = `${this.num}番目の行列`;
      if(this.type == 'surrus'){
	txt += 'に';
      }else if(this.type == 'mult' || this.type == 'swap' || this.type == 'add'){
	txt += 'の';
      }else{
	txt += 'を';
      }
    }
    if(this.type == 'calc'){
      txt = 'スカラーの計算';
    }else if(this.type == 'surrus'){
      txt += 'サラスの方法を適用';
    }else if(this.type == 'mult'){
      txt += `第${this.mult_i+1}${rc}を${coeff}倍する。`;
    }else if(this.type == 'swap'){
      txt += `第${this.swap_i1+1}${rc}と第${this.swap_i2+1}${rc}を入れ替える。`;
    }else if(this.type == 'add'){
      txt += `第${this.add_i1+1}${rc}の${coeff}倍を第${this.add_i2+1}${rc}に加える。`;
    }else if(this.type == 'deg'){
      txt += '次数下げ';
    }else if(this.type == 'expand'){
      txt += `第${this.expand_i+1}${rc}に関して展開する。`;
    }else{
      txt +='unknown type';
    }
    return txt;
  }
}

export class Config{
  constructor(v){
    this.type = 'char';
    this._char = 'x';
    this._show = v; // eqn, matrix, aug
    this.show2 = 'aug'; // eqn
    this.error = false;
    this.charList = 'xyzabcdefghijklmnopqrstuvw';
    this.constant = 'C';
  }
  get character(){
    return this._char;
  }
  set character(v){
    this._char = v;
    if(v.length == 1 && v.match(/[A-Za-z]/) ){
      this.error = false;
      const charList = v.match(/[a-z]/) ? 'xyzabcdefghijklmnopqrstuvw' : 'XYZABCDEFGHIJKLMNOPQRSTUVW';
      const index = charList.indexOf(v);
      this.charList = charList.slice(index) + charList.slice(0,index);
      this.constant = v.match(/[a-z]/) ? 'C' : 'a';
    }else{
      this.error = true;
    }
  }
  get show(){
    return this._show;
  }
  set show(v){
    this._show = v;
    if(v == 'matrix' || v == 'aug'){
      this.show2 = 'aug';
    }
  }
}
